import { bool, number, string } from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import styled from "styled-components/macro";

import classNames from "classnames";
import { motion } from "framer-motion"

import { HoverChild } from "UI/HoverChildren";
import { colors } from "UI/colors";

import { NewFeatureBadge } from "./NewFeatureBadge";


const hidden = { opacity: 0, height: 0 };
const visible = { opacity: 1, height: "auto" };

export default function CustomizeButton({
  isMounted,
  signupItemID,
  signupListID,
}) {
  return (
    <DescriptionButtonContainer
      initial={isMounted ? hidden : null}
      animate={visible}
    >
      <DescriptionButtonContainerInside>
        <HoverChild selected={signupItemID === "customize"}>
          <DescriptionButton
            data-cy="CustomizeButton"
            className={classNames({
              selected: signupItemID === "customize",
            })}
          >
            <Background />
            <Link to={`/signups/${signupListID}/items/customize`}>
              <DescriptionButtonInside
                whileHover={{ color: colors.fnBlue }}
                whileTap={{ scale: 0.94 }}
              >
                <Icon className="fad fa-paint-brush fa-swap-opacity" />
                <AddNewItemText>Customize</AddNewItemText>
                <NewFeatureBadge style={{marginLeft: '.5rem'}} />
              </DescriptionButtonInside>
            </Link>
          </DescriptionButton>
        </HoverChild>
      </DescriptionButtonContainerInside>
    </DescriptionButtonContainer>
  );
}

CustomizeButton.propTypes = {
    isMounted: bool.isRequired,
    signupItemID: string.isRequired,
    signupListID: number.isRequired,
};

const AddNewItemText = styled.div`
  margin-left: 8px;
`;
const DescriptionButtonContainer = styled(motion.div)`
  overflow: hidden;
`;

const DescriptionButtonContainerInside = styled.div`
  padding: 6px 6px;
  border-bottom: 1px solid #eceff0;
`;
const DescriptionButton = styled.div`
  & a {
    text-decoration: none !important;
    color: inherit;
  }

  user-select: none;

  position: relative;
  z-index: 100;
`;
const DescriptionButtonInside = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 16px;
  position: relative;
  z-index: 200;
`;

const Background = styled.div`
  border-radius: 8px;
  position: absolute;
  opacity: 0;
  z-index: 1;
  background: #eceff0;
  transition: transform 0.2s, opacity 0.2s, inset 0.2s;
  inset: 5px 6px;

  ${DescriptionButton}:hover & {
    inset: 2px;
  }

  ${DescriptionButton}.selected & {
    opacity: 1;
    transform: none;
    inset: 0;
  }
`;

const Icon = styled.i`
/* --fa-primary-color: crimson;
--fa-secondary-opacity: .6;
--fa-primary-opacity: .9; */
  /* --fa-primary-color: inherit;
  --fa-secondary-color: peru;
  --fa-secondary-opacity: 1;
  --fa-primary-opacity: .75; */
`;